// eslint-disable-next-line spaced-comment
///  <reference types="vite/client" />
import type { FC } from 'react'
import styles from './dev-banner.module.css'
import { getDevWorktreeInfo, hashStringToHue } from './dev-worktree.js'

export const DevBanner: FC = () => {
  if (!import.meta.env.DEV) {
    return null
  }
  const { branch, port } = getDevWorktreeInfo()
  const hue = hashStringToHue(branch)
  const background = `hsl(${hue} 65% 45%)`
  return (
    <div className={styles.banner} style={{ background }} role="status" aria-label="Development worktree indicator">
      :{port} · {branch}
    </div>
  )
}
